import React from 'react';

export const BPC157Diagram: React.FC = () => {
  return (
    <svg viewBox="0 0 800 650" xmlns="http://www.w3.org/2000/svg">
      {/* Title */}
      <text x="400" y="50" textAnchor="middle" fontSize="24" fontWeight="bold" fill="#2C3E50">
        BPC-157 Mechanisms of Action
      </text>

      {/* Central Peptide Structure */}
      <rect x="325" y="100" width="150" height="60" rx="10" fill="#3498DB" />
      <text x="400" y="140" textAnchor="middle" fontSize="18" fontWeight="bold" fill="white">
        BPC-157
      </text>

      {/* Main Pathways */}
      <g>
        {/* Left Side - GI Protection */}
        <path d="M325,130 L200,200" stroke="#2C3E50" strokeWidth="2" fill="none" />
        <rect x="100" y="180" width="180" height="60" rx="10" fill="#E74C3C" />
        <text x="190" y="215" textAnchor="middle" fontSize="16" fontWeight="bold" fill="white">
          GI Protection
        </text>

        {/* Right Side - Angiogenesis */}
        <path d="M475,130 L600,200" stroke="#2C3E50" strokeWidth="2" fill="none" />
        <rect x="520" y="180" width="180" height="60" rx="10" fill="#2ECC71" />
        <text x="610" y="215" textAnchor="middle" fontSize="16" fontWeight="bold" fill="white">
          Angiogenesis
        </text>

        {/* Center Down - Growth Factor Expression */}
        <path d="M400,160 L400,240" stroke="#2C3E50" strokeWidth="2" fill="none" />
        <rect x="310" y="240" width="180" height="60" rx="10" fill="#9B59B6" />
        <text x="400" y="275" textAnchor="middle" fontSize="16" fontWeight="bold" fill="white">
          Growth Factor Expression
        </text>
      </g>

      {/* Second Level Mechanisms */}
      <g>
        {/* GI Protection Details */}
        <path d="M160,240 L100,300" stroke="#2C3E50" strokeWidth="2" fill="none" />
        <rect x="20" y="300" width="160" height="50" rx="8" fill="#F1948A" />
        <text x="100" y="330" textAnchor="middle" fontSize="14" fill="#2C3E50">
          Mucosal Integrity
        </text>

        <path d="M220,240 L270,300" stroke="#2C3E50" strokeWidth="2" fill="none" />
        <rect x="200" y="300" width="160" height="50" rx="8" fill="#F1948A" />
        <text x="280" y="330" textAnchor="middle" fontSize="14" fill="#2C3E50">
          Dopamine System
        </text>

        {/* Angiogenesis Details */}
        <path d="M550,240 L490,300" stroke="#2C3E50" strokeWidth="2" fill="none" />
        <rect x="410" y="300" width="160" height="50" rx="8" fill="#ABEBC6" />
        <text x="490" y="330" textAnchor="middle" fontSize="14" fill="#2C3E50">
          VEGF Signaling
        </text>

        <path d="M670,240 L720,300" stroke="#2C3E50" strokeWidth="2" fill="none" />
        <rect x="640" y="300" width="160" height="50" rx="8" fill="#ABEBC6" />
        <text x="720" y="330" textAnchor="middle" fontSize="14" fill="#2C3E50">
          Nitric Oxide (NO)
        </text>
        
        {/* Growth Factor Details */}
        <path d="M370,300 L320,360" stroke="#2C3E50" strokeWidth="2" fill="none" />
        <rect x="240" y="360" width="160" height="50" rx="8" fill="#D7BDE2" />
        <text x="320" y="390" textAnchor="middle" fontSize="14" fill="#2C3E50">
          EGF Receptor
        </text>
        
        <path d="M430,300 L480,360" stroke="#2C3E50" strokeWidth="2" fill="none" />
        <rect x="400" y="360" width="160" height="50" rx="8" fill="#D7BDE2" />
        <text x="480" y="390" textAnchor="middle" fontSize="14" fill="#2C3E50">
          FGF Expression
        </text>
      </g>

      {/* Clinical Applications Box */}
      <rect x="100" y="450" width="600" height="140" rx="10" fill="#F8F9F9" stroke="#BDC3C7" strokeWidth="2" />
      <text x="400" y="480" textAnchor="middle" fontSize="18" fontWeight="bold" fill="#2C3E50">
        Key Clinical Applications
      </text>
      
      <text x="160" y="520" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#E74C3C">
        • GI Disorders
      </text>
      <text x="400" y="520" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#2ECC71">
        • Tendon & Muscle Healing
      </text>
      <text x="640" y="520" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#3498DB">
        • Wound Recovery
      </text>
      
      <text x="160" y="555" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#9B59B6">
        • Joint Repair
      </text>
      <text x="400" y="555" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#F39C12">
        • Neuroprotection
      </text>
      <text x="640" y="555" textAnchor="middle" fontSize="14" fontWeight="bold" fill="#16A085">
        • Inflammatory Conditions
      </text>
    </svg>
  );
};

export default BPC157Diagram;